import React, { Component } from "react";
import { Link } from "react-router-dom";
import { string } from "prop-types";
import * as i18nUtils from "util/i18n";

class MenuFormItem extends Component {
    static propTypes = {
        link: string.isRequired,
        name: string.isRequired,
    };

    setPageTitle = (name) => {
        document.title = name.includes("Bi-Bank") ? name : "Bi-Bank - ".concat(name);
    };

    render() {
        const { link, name, ...rest } = this.props;

        return (
            <Link to={link} role="menuitem" {...rest} onClick={() => this.setPageTitle(name)}>
                <span>{name}</span>
            </Link>
        );
    }
}

export default MenuFormItem;
